<!-- src/psych-test/components/PsychTest.vue -->
<template>
  <v-container max-width="700" class="py-8 fill-height" v-if="!result">
    <v-fade-transition mode="out-in">
      <v-row :key="1" v-if="state == 'questions'" justify="center" class="fill-height">
        <v-col cols="12" lg="4" md="6">

        <div>
          <div class="headerContext d-flex pt-8 justify-space-between">
            <div class="d-flex flex-row-reverse">
              <div class="questionCounter">
                {{ step }}
              </div>
              /
              <div class="totalQuestionCount">
                {{ questions.length }}
              </div>
            </div>
            <div>
              <img src="../assets/logo/Logo.svg" alt="">
            </div>
            <div>
              <div>
                <v-fade-transition>
                  <v-icon @click="step--" v-if="step != 1" style="cursor:pointer;">
                    mdi-arrow-left
                  </v-icon>
                </v-fade-transition>
              </div>
            </div>
          </div>
          <div class="progressArea mt-5">
            <v-progress-linear color="primary" :value="progress" background-color="rgb(216 221 221/1)" height="8"
                               rounded></v-progress-linear>
          </div>


          <v-stepper v-model="step" elevation="0">
            <!-- عناوین مراحل (شماره سؤال) -->


            <!-- محتوای هر مرحله (سؤال + گزینه‌ها) -->
            <v-stepper-items>
              <v-stepper-content
                  v-for="q in questions"
                  :key="q.id"
                  :step="q.id"
              >
                <div  class="pa-4">
                  <h3 class=" font-weight-bold mb-4">
                    <span>{{ q.text }}</span>
                  </h3>

                  <!-- گزینه‌ها به‌صورت دکمه -->
                  <div v-for="o in q.options" :key="o.label">
                    <v-checkbox
                        class="mb-2 text-right"
                        :color="btnColor(q.id, o)"
                        dense
                        @click="choose(q.id, o)"
                        :label="`${o.text}`"
                    >
                    </v-checkbox>

                  </div>
                </div>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </div>

        </v-col>
      </v-row>
      <v-row :key="2" v-else justify="center" class="fill-height">
        <v-col cols="12" lg="4" md="6" class=" fill-height">
          <div class="fill-height pb-5 d-flex justify-center flex-column">
            <div class="introSlide">
              <img src="../assets/Journey_inward.png" alt="">
              <div class="sliderContent">
                <div class="titleSlider">
                  سفر به درون از انتخاب مقصد شروع می‌شه!
                </div>
                <div class="contentSlider">
                  با پاسخ دادن به 6 سوال ساده، میفهمی کجای دنیا با حال‌وهوای درونی‌ات هم‌راستاست.
                </div>
                <div class="buttonSlier " @click="state = 'questions'">
                  بعدی
                </div>
              </div>
            </div>
          </div>

        </v-col>
      </v-row>
    </v-fade-transition>
  </v-container>

  <!-- نتیجه -->
  <PsychResult v-else/>
</template>

<script>
import {mapState, mapGetters, mapActions} from "vuex";
import PsychResult from "./PsychResult.vue";

export default {
  name: "PsychTestStepper",
  components: {PsychResult},

  data() {
    return {
      step: 1,
      state: 'questions',
    }; // v-model برای v-stepper

  },

  computed: {
    ...mapState("psychTest", ["questions", "answers", "result"]),
    ...mapGetters("psychTest", ["answeredCount"]),
    progress() {
      return (this.step / this.questions.length) * 100;
    }
  },

  methods: {
    ...mapActions("psychTest", ["saveAnswer", "calculate"]),

    /** کلیک روی گزینه */
    choose(qId, option) {
      this.saveAnswer({qId, option});

      // اگر آخرین سؤال نیست → برو به سؤال بعدی
      if (qId < this.questions.length) {
        this.step++;
      } else {
        // همه پاسخ داده شده: نتیجه را محاسبه کن
        this.calculate();
      }
    },

    /* استایل رنگ دکمه‌ها */
    btnColor(qId, option) {
      return this.answers[qId] === option ? "primary" : "grey lighten-2";
    },

    /* بررسی پاسخ داده‌شدن سؤال برای تکمیل Step */
    isAnswered(qId) {
      return !!this.answers[qId];
    },
  },
};
</script>

<style scoped>
.introSlide img {
  width: 40%;
}

.introSlide {
  text-align: center;
  direction: rtl;
}

.questionCounter {
  color: rgb(119 137 137/1);
}

.totalQuestionCount {
  color: rgb(61 86 86/1);
  font-family: bold !important;
}

.headerContext {
  direction: rtl !important;
  justify-content: space-between;
}

.buttonSlier {
  background: #1cba88;
  padding: 10px;
  font-family: bold !important;
  color: white;
  cursor: pointer;
  border-radius: 12px;
  margin-top: 50px;
  text-align: center;
}

.titleSlider {
  font-size: 15pt;
  font-family: bold !important;
  color: rgb(61 86 86/1);
  margin-bottom: 10px;
}

.contentSlider {
  font-size: 11pt;
  color: rgb(61 86 86/1);

}
</style>
